import { capitalize } from 'vue';

import IABCategoryEnum from '@/common/enums/IABCategory.enum';
import i18n from '@/vueI18n';

import IABCategory from './IABCategory';

export default class IABCategories {
  private static optionsInternal: IABCategory[] | null = null;

  static init() {
    IABCategories.optionsInternal = null;
  }

  static getLocalizedOptionName(name: string): string {
    return capitalize(i18n.global.t(`options.iabCategories.${name}`));
  }

  static getIABSubcategories(categoryID, nbOfSubCategories) {
    const subCategories = [];
    subCategories.push(new IABCategory(categoryID, this.getLocalizedOptionName(categoryID)));
    for (let i = 1; i <= nbOfSubCategories; i += 1) {
      const subCategoryID = `${categoryID}-${i}`;
      const subCategoryOptionName = `${categoryID}_${i}`;
      subCategories.push(
        new IABCategory(subCategoryID, this.getLocalizedOptionName(subCategoryOptionName), categoryID),
      );
    }
    return subCategories;
  }

  static options(): IABCategory[] {
    if (this.optionsInternal === null) {
      this.optionsInternal = [
        ...this.getIABSubcategories(IABCategoryEnum.IAB1, 7),
        ...this.getIABSubcategories(IABCategoryEnum.IAB2, 23),
        ...this.getIABSubcategories(IABCategoryEnum.IAB3, 12),
        ...this.getIABSubcategories(IABCategoryEnum.IAB4, 11),
        ...this.getIABSubcategories(IABCategoryEnum.IAB5, 15),
        ...this.getIABSubcategories(IABCategoryEnum.IAB6, 9),
        ...this.getIABSubcategories(IABCategoryEnum.IAB7, 45),
        ...this.getIABSubcategories(IABCategoryEnum.IAB8, 18),
        ...this.getIABSubcategories(IABCategoryEnum.IAB9, 31),
        ...this.getIABSubcategories(IABCategoryEnum.IAB10, 9),
        ...this.getIABSubcategories(IABCategoryEnum.IAB11, 5),
        ...this.getIABSubcategories(IABCategoryEnum.IAB12, 3),
        ...this.getIABSubcategories(IABCategoryEnum.IAB13, 12),
        ...this.getIABSubcategories(IABCategoryEnum.IAB14, 8),
        ...this.getIABSubcategories(IABCategoryEnum.IAB15, 10),
        ...this.getIABSubcategories(IABCategoryEnum.IAB16, 7),
        ...this.getIABSubcategories(IABCategoryEnum.IAB17, 44),
        ...this.getIABSubcategories(IABCategoryEnum.IAB18, 6),
        ...this.getIABSubcategories(IABCategoryEnum.IAB19, 36),
        ...this.getIABSubcategories(IABCategoryEnum.IAB20, 27),
        ...this.getIABSubcategories(IABCategoryEnum.IAB21, 3),
        ...this.getIABSubcategories(IABCategoryEnum.IAB22, 4),
        ...this.getIABSubcategories(IABCategoryEnum.IAB23, 10),
        ...this.getIABSubcategories(IABCategoryEnum.IAB24, 0),
        ...this.getIABSubcategories(IABCategoryEnum.IAB25, 7),
        ...this.getIABSubcategories(IABCategoryEnum.IAB26, 4),
      ];
    }
    return this.optionsInternal;
  }

  static hierarchicalOptions(): IABCategory[] {
    const categories: IABCategory[] = [];
    let lastTopCategory: IABCategory | null = null;

    IABCategories.options().forEach((x) => {
      if (x.isTopCategory) {
        lastTopCategory = new IABCategory(x.id, x.name);
        categories.push(lastTopCategory);
      } else if (lastTopCategory) {
        const subCategory = new IABCategory(x.id, x.name, lastTopCategory.id);
        lastTopCategory.subCategories.push(subCategory);
      }
    });

    return categories;
  }

  static subCategoriesOptions(): IABCategory[] {
    return IABCategories.options().filter((x) => !x.isTopCategory);
  }
}
